export class ItemUtils {
    /**
     * Calculates the number of packing units needed for a given quantity and packing unit size.
     * @param quantity The total quantity of items needed
     * @param packingUnitSize The number of items in each packing unit
     * @returns The number of complete packing units needed
     */
    public static calculatePackingUnits(quantity: number, packingUnitSize: number): number {
        return Math.ceil(quantity / packingUnitSize);
    }
}